import { render, staticRenderFns } from "./DropdownFilter.vue?vue&type=template&id=c37819dc&scoped=true&"
import script from "./DropdownFilter.vue?vue&type=script&lang=js&"
export * from "./DropdownFilter.vue?vue&type=script&lang=js&"
import style0 from "./DropdownFilter.vue?vue&type=style&index=0&id=c37819dc&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37819dc",
  null
  
)

export default component.exports